import React, { useState } from 'react';
import { Divider, IconButton, InputBase, makeStyles, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

export default function SearchCustomInput({ onClick, value = '' }) {
  const [ inpValue, setInpValue ] = useState(value);
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <InputBase
        className={classes.input}
        value={inpValue}
        placeholder="Pesquisar por nome"
        onChange={(event) => {
          setInpValue(event.target.value)
        }}
        inputProps={{ 'aria-label': 'Pesquisar por nome' }}
      />
      {
        inpValue && 
        <>
          <IconButton className={classes.iconButton} aria-label="Search" onClick={(event) => {
            onClick(event, '');
            setInpValue('');
          }}>
            <CloseIcon />
          </IconButton>
          <Divider className={classes.divider} />
        </>
      }
      <IconButton className={classes.iconButton} aria-label="Search" onClick={(event) => {
        onClick(event, inpValue)
      }}>
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}